import styled, { css } from 'styled-components';

import Tooltip from '../Tooltip';

interface ContainerProps {
  isErrored: boolean;
  isTextArea: boolean;
}

export const Container = styled.div<ContainerProps>`
  background-color: var(--color-black);
  border: 3px solid var(--color-yellow);
  border-radius: 25px;
  padding: 16px 16px 16px 24px;
  width: 100%;
  color: var(--color-white);

  display: flex;
  align-items: center;

  & + div {
    margin-top: 8px;
  }

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  textarea {
    flex: 1;
    background: transparent;
    border: 0;
    height: 250px;
    color: var(--color-white);
    resize: none;
  }

  svg {
    margin-right: 16px;
  }
`;

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
